const resuriveClear = (formData: any, key: string, setEmptyFieldAs?: any) => {
  var isObjectNull = false;
  if (typeof formData[key] === "object" && formData[key] !== null) {
    const keys = Object.keys(formData[key]);
    if (keys && keys.length > 0) {
      keys.forEach((key2) => {
        resuriveClear(formData[key], key2, setEmptyFieldAs);
      });
      isObjectNull = Object.keys(formData[key]).length === 0;
    }
  }

  if (
    isObjectNull ||
    formData[key] === "" ||
    formData[key] === null ||
    Number.isNaN(formData[key]) ||
    formData[key] === undefined
  ) {
    if (setEmptyFieldAs !== undefined)
      formData[key] = setEmptyFieldAs
    else
      delete formData[key]
  }
};

const clearEmptyFields = (formData: any, setEmptyFieldAsNull?: boolean | null) =>
{
  Object.keys(formData).forEach((key) => {
    resuriveClear(formData, key, setEmptyFieldAsNull);
  })
  return formData
}
  

export default clearEmptyFields;